import React from "react";

const Loader = () => {
    return (
        <div className="loader-container pt-4 pb-4 d-flex justify-content-center bg-primary">
            <div className="loader-icons">
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
                <div className="loader-icon"></div>
            </div>
        </div>
    )
}

export default Loader;